// Seeded RNG — deterministic procedural variation for reproducible QA shots.
// Pattern reference: Juanmaes83/threejs-game-skills (seeded RNG determinism).
// Method: REFERENCE (no code copied).

export function createRng(seed = 1) {
  let state = seed >>> 0 || 1;
  // mulberry32
  const next = () => {
    state |= 0;
    state = (state + 0x6d2b79f5) | 0;
    let t = Math.imul(state ^ (state >>> 15), 1 | state);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
  next.range = (min, max) => min + next() * (max - min);
  next.pick = (list) => list[Math.floor(next() * list.length) % list.length];
  return next;
}

export function seedFromUrl(params, fallback = 20260817) {
  const raw = params.get('seed');
  const parsed = Number(raw);
  return Number.isFinite(parsed) && raw !== null ? parsed : fallback;
}
